import { PassThrough } from '@primevue/core';

export type MessageStatus = 'info' | 'warning' | 'error' | 'success';
export type MessageType = 'banner' | 'inline' | 'toast';
export type MessageSize = 'big' | 'base' | 'small';

// Export const objects for use in component logic and stories
export const MessageStatusOptions = {
  INFO: 'info' as MessageStatus,
  WARNING: 'warning' as MessageStatus,
  ERROR: 'error' as MessageStatus,
  SUCCESS: 'success' as MessageStatus,
} as const;

export const MessageTypeOptions = {
  BANNER: 'banner' as MessageType,
  INLINE: 'inline' as MessageType,
  TOAST: 'toast' as MessageType,
} as const;

export const MessageSizeOptions = {
  BIG: 'big' as MessageSize,
  BASE: 'base' as MessageSize,
  SMALL: 'small' as MessageSize,
} as const;

export interface MessageProps {
  status: MessageStatus;
  type: MessageType;
  size: MessageSize;
  close?: boolean;
  title?: string;
  body?: string;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  pt?: PassThrough<MessagePassThroughOptions>;
}

export type MessagePassThroughOptionType =
  | MessagePassThroughAttributes
  | ((
      options: MessagePassThroughMethodOptions
    ) => MessagePassThroughAttributes | string)
  | string
  | null
  | undefined;

export interface MessagePassThroughAttributes {
  [key: string]: any;
}

export interface MessagePassThroughMethodOptions {
  instance: any;
  props: MessageProps;
  state: MessageState;
}

export interface MessageState {
  visible: boolean;
}

export interface MessagePassThroughOptions {
  root?: MessagePassThroughOptionType;
  icon?: MessagePassThroughOptionType;
  content?: MessagePassThroughOptionType;
  title?: MessagePassThroughOptionType;
  body?: MessagePassThroughOptionType;
  closeButton?: MessagePassThroughOptionType;
  actions?: MessagePassThroughOptionType;
  primaryButton?: MessagePassThroughOptionType;
  secondaryButton?: MessagePassThroughOptionType;
}

export interface MessageEmits {
  close: [];
  primaryAction: [];
  secondaryAction: [];
}
